import { useTranslation } from 'react-i18next'
import styles from './PartnerBanner.module.scss'

type PartnerBannerProps = Readonly<{
  banner?: string | null
}>

export function PartnerBanner({ banner }: PartnerBannerProps) {
  const { t } = useTranslation()

  if (!banner) return null

  return (
    <img
      src={banner}
      alt={t('agentVerificationDocuments.partnerBannerAlt')}
      className={styles.partnerBanner}
      data-testid="partner-banner"
    />
  )
}
